/*
  MX Upselling (eigene Lösung, ohne App)
  1. Pop-up nach „In den Warenkorb“: Bestätigung + passende Produkte mit Ein-Klick-Hinzufügen
     (Inhalt: sections/mx-upsell-popup.liquid, Regeln: snippets/mx-upsell-liste.liquid)
  2. Empfehlungen in der Warenkorb-Schublade und auf der Warenkorbseite (snippets/mx-cart-upsell.liquid)
  3. Messung: Jede Empfehlung kommt mit der Eigenschaft _mx_upsell = popup | drawer | cart in den Warenkorb
     (unsichtbar für Kunden, sichtbar in der Bestellung). Wie oft Pop-up und Schublade gezeigt wurden, steht im
     Warenkorb-Attribut _mx_upsell_views und landet so ebenfalls an der Bestellung.
     Zusätzlich Ereignisse für Shopify-Kundenereignisse (mx_upsell_view / mx_upsell_add) und dataLayer.
  Einstieg: product-form.js ruft MXUpsell.afterAdd(cart, antwort) auf. Gibt die Funktion false zurück,
  öffnet sich wie bisher die Warenkorb-Schublade.
*/
(function () {
  'use strict';
  var CFG = window.MXUP || { popup: true };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SEC = 'mx-upsell-popup';
  var DISMISS_KEY = 'mxu_zu';
  var VIEWS_KEY = 'mxu_views';
  var pop, slot, cartRef, lastFocus, addedInPopup = false, curUrl = '', openedAt = 0;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function money(c) {
    var n = Number(c || 0) / 100;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur, minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n); }
    catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }
  function sectionInner(html) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var el = d.querySelector('.shopify-section') || d.body;
    return el ? el.innerHTML : '';
  }

  /* ---------- Messung ---------- */
  function emit(action, data) {
    data = data || {};
    data.action = action;
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('mx_upsell_' + action, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'mx_upsell_' + action, mx_upsell: data }); } catch (e) {}
  }
  var viewTimer = null;
  function countView(src) {
    var v = {};
    try { v = JSON.parse(ss(VIEWS_KEY) || '{}') || {}; } catch (e) { v = {}; }
    v[src] = (v[src] || 0) + 1;
    ss(VIEWS_KEY, JSON.stringify(v));
    clearTimeout(viewTimer);
    viewTimer = setTimeout(function () {
      var val = Object.keys(v).map(function (k) { return k + ':' + v[k]; }).join(',');
      fetch(ROOT + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _mx_upsell_views: val } })
      }).catch(function () {});
    }, 1200);
  }
  function cardsInfo(root) {
    return $$('[data-mxu-card]', root).map(function (c) { return c.getAttribute('data-handle'); });
  }

  /* ---------- Warenkorb-Schublade still aktualisieren (ohne sie zu öffnen) ---------- */
  function renderDrawerSilently(cart, state) {
    if (!cart || !state || !state.sections || typeof cart.getSectionsToRender !== 'function') return;
    cart.getSectionsToRender().forEach(function (s) {
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (!el || !state.sections[s.id]) return;
      el.innerHTML = cart.getSectionInnerHTML(state.sections[s.id], s.selector);
    });
    cart.classList.remove('is-empty');
    var inner = cart.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    var ov = cart.querySelector('#CartDrawer-Overlay');
    if (ov && !ov.__mxu) { ov.__mxu = true; ov.addEventListener('click', cart.close.bind(cart)); }
  }
  function publishCart(state, id) {
    try { if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mx-upsell', productVariantId: id, cartData: state }); } catch (e) {}
  }

  /* ---------- Pop-up ---------- */
  function shell() {
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'mxu-pop';
    pop.id = 'mxu-pop';
    pop.setAttribute('hidden', '');
    pop.innerHTML =
      '<div class="mxu-pop__ov" data-mxu-close></div>' +
      '<div class="mxu-pop__box" role="dialog" aria-modal="true" aria-labelledby="mxu-pop-t" tabindex="-1">' +
        '<button type="button" class="mxu-pop__x" data-mxu-close aria-label="Schließen"><svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>' +
        '<div class="mxu-pop__top">' +
          '<p class="mxu-pop__t" id="mxu-pop-t"><span class="mxu-pop__ok" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 14 14"><path d="M2.5 7.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>Im Warenkorb</p>' +
          '<div class="mxu-pop__added" data-mxu-added></div>' +
        '</div>' +
        '<div class="mxu-pop__slot" data-mxu-slot></div>' +
        '<div class="mxu-pop__ft">' +
          '<button type="button" class="mxu-btn mxu-btn--line" data-mxu-cart>Zum Warenkorb</button>' +
          '<a class="mxu-btn mxu-btn--pri" href="' + ROOT + 'checkout" data-mxu-checkout>Zur Kasse</a>' +
          '<button type="button" class="mxu-pop__more" data-mxu-close>Weiter einkaufen</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(pop);
    slot = $('[data-mxu-slot]', pop);
    pop.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-mxu-close]')) { ev.preventDefault(); closePop(); return; }
      if (ev.target.closest('[data-mxu-cart]')) { ev.preventDefault(); closePop(true); if (cartRef) cartRef.open(); return; }
      if (ev.target.closest('[data-mxu-checkout]')) { emit('checkout', { source: 'popup' }); }
    });
    pop.addEventListener('keyup', function (ev) { if (ev.code === 'Escape') closePop(); });
    return pop;
  }
  function skeleton() {
    var c = '';
    for (var i = 0; i < 4; i++) c += '<div class="mxu-c mxu-c--sk" aria-hidden="true"><span class="mxu-c__img"></span><div class="mxu-c__b"><i></i><i></i><i></i></div></div>';
    return '<div class="mxu-pop__body"><p class="mxu-pop__h">Passt dazu</p><div class="mxu-pop__grid">' + c + '</div></div>';
  }
  function addedHtml(state) {
    var img = state.featured_image && state.featured_image.url ? state.featured_image.url : state.image;
    if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    var v = state.variant_title && !/default title/i.test(state.variant_title) ? state.variant_title : '';
    var q = state.quantity > 1 ? state.quantity + ' × ' : '';
    return (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="eager">' : '<span></span>') +
      '<span class="mxu-pop__an"><b>' + esc((state.product_title || state.title || '').split(' – ')[0]) + '</b>' +
      (v ? '<small>' + esc(v.replace(/\/\/\/M/g, 'M')) + '</small>' : '') + '</span>' +
      '<b class="mxu-pop__ap">' + q + money(state.final_price != null ? state.final_price : state.price) + '</b>';
  }
  function popupUrl(state) {
    var u = state && state.url ? String(state.url) : '';
    if (!u || u.indexOf('/products/') < 0) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + SEC;
  }
  function openPop(cart, state) {
    shell();
    cartRef = cart;
    addedInPopup = false;
    openedAt = Date.now();
    curUrl = popupUrl(state);
    $('[data-mxu-added]', pop).innerHTML = addedHtml(state);
    slot.innerHTML = skeleton();
    lastFocus = document.activeElement;
    pop.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden', 'mxu-open');
    requestAnimationFrame(function () { pop.classList.add('is-open'); });
    var box = $('.mxu-pop__box', pop);
    if (typeof trapFocus === 'function') trapFocus(box, box); else box.focus();
    return fetch(curUrl, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var inner = sectionInner(html);
        if (!inner || inner.indexOf('data-mxu-body') < 0) throw new Error('leer');
        slot.innerHTML = inner;
        var shown = cardsInfo(slot);
        countView('popup');
        emit('view', { source: 'popup', product: state.handle, items: shown });
      });
  }
  function refreshPop() {
    if (!curUrl || !pop || pop.hasAttribute('hidden')) return;
    fetch(curUrl, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var d = document.createElement('div');
      d.innerHTML = sectionInner(html);
      ['[data-mxu-ship]', '[data-mxu-cartinfo]', '[data-mxu-oel]'].forEach(function (sel) {
        var a = $(sel, slot), b = $(sel, d);
        if (a && b) a.innerHTML = b.innerHTML;
        else if (a && !b) a.remove();
      });
    }).catch(function () {});
  }
  function closePop(toCart) {
    if (!pop || pop.hasAttribute('hidden')) return;
    pop.classList.remove('is-open');
    document.body.classList.remove('mxu-open');
    if (!toCart) document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(lastFocus); else if (lastFocus) lastFocus.focus();
    setTimeout(function () { pop.setAttribute('hidden', ''); }, 220);
    if (addedInPopup) ss(DISMISS_KEY, '0');
    else if (!toCart) ss(DISMISS_KEY, String((parseInt(ss(DISMISS_KEY) || '0', 10) || 0) + 1));
    emit('close', { source: 'popup', added: addedInPopup, to_cart: !!toCart, seconds: Math.round((Date.now() - openedAt) / 1000) });
  }

  window.MXUpsell = {
    afterAdd: function (cart, state) {
      if (!CFG.popup || !cart || cart.tagName !== 'CART-DRAWER' || !state || !state.sections) return false;
      if ((parseInt(ss(DISMISS_KEY) || '0', 10) || 0) >= 3) return false;
      if (!popupUrl(state)) return false;
      renderDrawerSilently(cart, state);
      openPop(cart, state).catch(function () {
        /* Kein Inhalt oder Fehler: wie bisher die Schublade öffnen */
        if (pop) { pop.classList.remove('is-open'); pop.setAttribute('hidden', ''); document.body.classList.remove('mxu-open'); }
        cart.open();
      });
      return true;
    },
    close: closePop
  };

  /* ---------- Ein-Klick-Hinzufügen (Pop-up, Schublade, Warenkorbseite) ---------- */
  document.addEventListener('change', function (ev) {
    var sel = ev.target.closest && ev.target.closest('[data-mxu-var]');
    if (!sel) return;
    var card = sel.closest('[data-mxu-card]');
    var opt = sel.options[sel.selectedIndex];
    var p = card && $('[data-mxu-price]', card);
    if (p && opt && opt.getAttribute('data-price')) p.textContent = opt.getAttribute('data-price');
  });
  document.addEventListener('click', function (ev) {
    var sc = ev.target.closest && ev.target.closest('[data-mxu-scroll]');
    if (sc) {
      var row = sc.closest('[data-mxu-drawer]');
      row = row && $('[data-mxu-row]', row);
      if (row) row.scrollBy({ left: parseInt(sc.getAttribute('data-mxu-scroll'), 10) * row.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    var b = ev.target.closest && ev.target.closest('[data-mxs-add]');
    if (!b) return;
    ev.preventDefault();
    if (b.getAttribute('aria-disabled') === 'true') return;
    var card = b.closest('[data-mxu-card]');
    var sel = card && $('[data-mxu-var]', card);
    var id = parseInt(sel ? sel.value : b.getAttribute('data-mxs-add'), 10);
    var src = b.getAttribute('data-mx-src') || (b.closest('#mxu-pop') ? 'popup' : (b.closest('cart-drawer') ? 'drawer' : 'cart'));
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: id, quantity: 1, properties: { _mx_upsell: src } }] };
    if (drawer && src !== 'cart') body.sections = 'cart-drawer,cart-icon-bubble';
    var label = b.querySelector('span') || b;
    var old = label.textContent;
    b.setAttribute('aria-disabled', 'true');
    b.classList.add('is-busy');
    label.textContent = '…';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (!j || j.status) {
        label.textContent = 'Nicht verfügbar';
        b.classList.remove('is-busy');
        return;
      }
      emit('add', { source: src, product: card ? card.getAttribute('data-handle') : '', variant: id, position: card ? card.getAttribute('data-pos') : '', price: j.final_price });
      if (src === 'cart') { window.location.reload(); return; }
      if (src === 'popup') {
        addedInPopup = true;
        renderDrawerSilently(drawer, j);
        publishCart(j, id);
        b.classList.remove('is-busy');
        b.classList.add('is-done');
        label.textContent = '✓ Hinzugefügt';
        if (card) card.classList.add('is-added');
        if (sel) sel.disabled = true;
        refreshPop();
        return;
      }
      if (drawer && j.sections && typeof drawer.renderContents === 'function') {
        j.id = id;
        drawer.renderContents(j);
        publishCart(j, id);
      } else {
        window.location.reload();
      }
    }).catch(function () {
      b.removeAttribute('aria-disabled');
      b.classList.remove('is-busy');
      label.textContent = old;
    });
  });

  /* ---------- Schublade: Empfehlungen gesehen? ---------- */
  function watchDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d || d.__mxuWatch) return;
    d.__mxuWatch = true;
    var was = d.classList.contains('active');
    new MutationObserver(function () {
      var now = d.classList.contains('active');
      if (now && !was) {
        setTimeout(function () {
          var box = $('[data-mxu-drawer]', d);
          if (box && box.offsetParent !== null) {
            countView('drawer');
            emit('view', { source: 'drawer', items: cardsInfo(box) });
          }
        }, 450);
      }
      was = now;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();
  /* Warenkorbseite */
  if (document.querySelector('[data-mxu-page]') && /\/cart\/?$/.test(location.pathname)) {
    var pg = document.querySelector('[data-mxu-page]');
    if (!ss('mxu_cartview_' + location.pathname)) { countView('cart'); ss('mxu_cartview_' + location.pathname, '1'); }
    emit('view', { source: 'cart', items: cardsInfo(pg) });
  }
})();
